module.exports = __webpack_public_path__ + "static/media/greenhouse3-04.1630925c.webp";